const modalIsEnabled = window.abModalVariant !== 8

$('.swiper-button-next, .swiper-button-prev').on('click', function () {
    if ($('.swiper-slide.swiper-slide-visible video').length > 0) {
        $('.swiper-slide.swiper-slide-visible video')[0].play();
    }
});

window.postModal = false

async function mulberryInit() {
    window.postAdd = false
    var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
    var product = response.product
    var selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)
    var selectedWarranty

    var offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: product.title,
        price: selectedVariant.price,
        detail: product
    })

    if(offers.length === 0) {
        return
    }

    window.pdpModal = await mulberry.modal.init({
        offers: offers,
        placement: 'pdp',
        settings: mulberry.core.settings,
        onWarrantySelect: async function(warranty) {
            var result = await mulberryShop.getWarrantyVariant(warranty)
            selectedWarranty = warranty
            await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: selectedVariant.id}, selectedWarranty)

            setTimeout(function() {
                window.postModal = true
            }, 500)

        },
        onWarrantyDecline: async function() {
            window.pdpModal.close()
            window.postModal = true

        }
    })

    document.addEventListener('mulberry-shopify:variant-change', async function(e) {
        selectedVariant = product.variants.find(i => i.id == e.detail.variantId)
        offers = await mulberry.core.getWarrantyOffer({
            id: selectedVariant.id,
            title: product.title,
            price: selectedVariant.price,
            detail: product
        })
        mulberry.modal.updateOffer(offers);
    });

    const modalIsEnabled = window.abModalVariant !== 8
    console.log({ modalIsEnabled })

    let addToCart = document.querySelector('[data-submit-button]')
    if (document.querySelector('[data-submit-button]')) {
        console.log('mb')
        addToCart.addEventListener('click', function(e) {
            if (modalIsEnabled) {
                e.preventDefault()
                window.pdpModal.open()
                var modalOpened = setInterval(async function() {
                    if (window.postModal) {
                        submitProducts()
                        clearInterval(modalOpened)
                    }
                }, 100)
            }
        })
    }


    let customAddToCart = document.querySelector('#customAddToCart')
    if (document.querySelector('#customAddToCart')) {
        customAddToCart.addEventListener('click', function(e) {
            if (modalIsEnabled) {
                e.preventDefault()
                window.pdpModal.open()
                var modalOpened = setInterval(async function() {
                    if (window.postModal) {
                        submitProducts()
                        clearInterval(modalOpened)
                    }
                }, 100)
            }
        })
    }

}



async function removeAndSyncWarranties() {
    await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (cart) {
        cart.json().then(function (firstCart) {
            mulberryShop.removeDetachedWarranty(firstCart)
                .then(newCart => {
                    mulberryShop.cart.syncQuantities(newCart)
                        .then(function() {
                            window.location.href = '/cart'
                        })
                })
        })
    });
}



document.addEventListener('mulberry-shopify:loaded', async function() {
    if(window.location.href.indexOf("products") != -1 ) {
        await mulberryInit()
    }
})

//AJAX CART

// FORMAT MONEY FOR SHOPIFY PRICES
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.',''); }
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal   = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number/100.0).toFixed(precision);

		var parts   = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents   = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch(formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', function () {
  	if ($('#ajax-cart-drawer.test').length > 0) {
      let cartOpener = $('.header__btn-cart');
      let ajaxDrawer = $('#ajax-cart-drawer');
      let bgDrawer = $('.drawer-bg');

      cartOpener.on('click', function (e) {
          e.preventDefault();

          if (ajaxDrawer.hasClass('animate__slideInLeft')) {
              ajaxDrawer.removeClass('animate__slideInLeft');
          }

          if (ajaxDrawer.hasClass('animate__slideOutRight')) {
              ajaxDrawer.removeClass('animate__slideOutRight');
          }

          $('body, html').addClass('lock');

          ajaxDrawer.css('display', 'flex');
          bgDrawer.css('display', 'block');
          ajaxDrawer.addClass('animate__slideInRight');
      });

      bgDrawer.on('click', function (e) {
          e.preventDefault();

          $('[data-close-drawer]')[0].click();
      });

      $('[data-close-drawer]').on('click', function (e) {
          e.preventDefault();

          if (ajaxDrawer.hasClass('animate__slideInRight')) {
              ajaxDrawer.removeClass('animate__slideInRight');
          }

          ajaxDrawer.addClass('animate__slideOutRight');

          $('body, html').removeClass('lock');

          setTimeout(() => {
              bgDrawer.css('display', 'none');
          }, 1000);
      });

      renderAjaxCartItems(false);

      setTimeout(() => {
          jcf.replace($('.item-qty'));
          addRemoveListeners();
          addChangeProductsQtyListeners();
      }, 600);

      let findPayPal = setInterval(function () {
          if ($('.paypalLight').length > 0) {
              clearInterval(findPayPal);

              $('.paypalLight').closest('li').append("<a href='#' class='paypal_btn'><svg xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:cc=\"http://creativecommons.org/ns#\" xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 526.77502 140.375\" height=\"150\" width=\"70\" xml:space=\"preserve\" version=\"1.1\" id=\"svg2\"><metadata id=\"metadata8\"><rdf:RDF><cc:Work rdf:about=\"\"><dc:format>image/svg+xml</dc:format><dc:type rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\"/></cc:Work></rdf:RDF></metadata><defs id=\"defs6\"/><g transform=\"matrix(1.25,0,0,-1.25,0,140.375)\" id=\"g10\"><g transform=\"scale(0.1,0.1)\" id=\"g12\"><path id=\"path14\" style=\"fill:#283b82;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"m 505.703,1122.93 -327.781,0 c -22.434,0 -41.508,-16.3 -45.008,-38.45 L 0.34375,243.961 C -2.29297,227.383 10.5547,212.426 27.375,212.426 l 156.488,0 c 22.43,0 41.504,16.293 45.004,38.484 l 35.754,226.699 c 3.453,22.196 22.574,38.493 44.957,38.493 l 103.766,0 c 215.918,0 340.531,104.484 373.078,311.535 14.664,90.586 0.621,161.758 -41.797,211.603 -46.586,54.74 -129.215,83.69 -238.922,83.69 z M 543.52,815.941 C 525.594,698.324 435.727,698.324 348.832,698.324 l -49.461,0 34.699,219.656 c 2.063,13.278 13.563,23.055 26.985,23.055 l 22.668,0 c 59.191,0 115.031,0 143.882,-33.738 17.208,-20.133 22.481,-50.039 15.915,-91.356\"/><path id=\"path16\" style=\"fill:#283b82;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"m 1485.5,819.727 -156.96,0 c -13.37,0 -24.92,-9.778 -26.99,-23.055 l -6.94,-43.902 -10.98,15.914 c -33.98,49.32 -109.76,65.804 -185.39,65.804 -173.451,0 -321.599,-131.371 -350.451,-315.656 -15,-91.926 6.328,-179.828 58.473,-241.125 47.832,-56.363 116.273,-79.848 197.708,-79.848 139.76,0 217.26,89.86 217.26,89.86 l -7,-43.614 c -2.64,-16.679 10.21,-31.632 26.94,-31.632 l 141.38,0 c 22.48,0 41.46,16.297 45.01,38.484 l 84.83,537.234 c 2.69,16.536 -10.11,31.536 -26.89,31.536 z M 1266.71,514.23 c -15.14,-89.671 -86.32,-149.875 -177.09,-149.875 -45.58,0 -82.01,14.622 -105.401,42.325 -23.196,27.511 -32.016,66.668 -24.633,110.285 14.137,88.906 86.514,151.066 175.894,151.066 44.58,0 80.81,-14.808 104.68,-42.746 23.92,-28.23 33.4,-67.629 26.55,-111.055\"/><path id=\"path18\" style=\"fill:#283b82;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"m 2321.47,819.727 -157.73,0 c -15.05,0 -29.19,-7.477 -37.72,-19.989 L 1908.47,479.289 1816.26,787.23 c -5.8,19.27 -23.58,32.497 -43.71,32.497 l -155,0 c -18.84,0 -31.92,-18.403 -25.93,-36.137 L 1765.36,273.727 1602.02,43.1406 C 1589.17,24.9805 1602.11,0 1624.31,0 l 157.54,0 c 14.95,0 28.95,7.28906 37.43,19.5586 L 2343.9,776.828 c 12.56,18.121 -0.33,42.899 -22.43,42.899\"/><path id=\"path20\" style=\"fill:#469bdb;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"m 2843.7,1122.93 -327.83,0 c -22.38,0 -41.46,-16.3 -44.96,-38.45 L 2338.34,243.961 c -2.63,-16.578 10.21,-31.535 26.94,-31.535 l 168.23,0 c 15.62,0 29,11.402 31.44,26.933 l 37.62,238.25 c 3.45,22.196 22.58,38.493 44.96,38.493 l 103.72,0 c 215.96,0 340.53,104.484 373.12,311.535 14.72,90.586 0.58,161.758 -41.84,211.603 -46.54,54.74 -129.12,83.69 -238.83,83.69 z m 37.82,-306.989 C 2863.64,698.324 2773.78,698.324 2686.83,698.324 l -49.41,0 34.75,219.656 c 2.06,13.278 13.46,23.055 26.93,23.055 l 22.67,0 c 59.15,0 115.03,0 143.88,-33.738 17.21,-20.133 22.43,-50.039 15.87,-91.356\"/><path id=\"path22\" style=\"fill:#469bdb;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"m 3823.46,819.727 -156.87,0 c -13.47,0 -24.93,-9.778 -26.94,-23.055 l -6.95,-43.902 -11.02,15.914 c -33.98,49.32 -109.71,65.804 -185.34,65.804 -173.46,0 -321.55,-131.371 -350.41,-315.656 -14.95,-91.926 6.28,-179.828 58.43,-241.125 47.93,-56.363 116.27,-79.848 197.7,-79.848 139.76,0 217.26,89.86 217.26,89.86 l -7,-43.614 c -2.63,-16.679 10.21,-31.632 27.04,-31.632 l 141.34,0 c 22.38,0 41.46,16.297 44.96,38.484 l 84.88,537.234 c 2.58,16.536 -10.26,31.536 -27.08,31.536 z M 3604.66,514.23 c -15.05,-89.671 -86.32,-149.875 -177.09,-149.875 -45.49,0 -82.01,14.622 -105.4,42.325 -23.19,27.511 -31.92,66.668 -24.63,110.285 14.23,88.906 86.51,151.066 175.9,151.066 44.57,0 80.8,-14.808 104.67,-42.746 24.01,-28.23 33.5,-67.629 26.55,-111.055\"/><path id=\"path24\" style=\"fill:#469bdb;fill-opacity:1;fill-rule:nonzero;stroke:none\" d=\"M 4008.51,1099.87 3873.97,243.961 c -2.63,-16.578 10.21,-31.535 26.94,-31.535 l 135.25,0 c 22.48,0 41.56,16.293 45.01,38.484 l 132.66,840.47 c 2.64,16.59 -10.2,31.59 -26.93,31.59 l -151.46,0 c -13.37,-0.04 -24.87,-9.83 -26.93,-23.1\"/></g></g></svg></a>");
          }
      }, 1000);
  	}
});

window.renderWithListeners = function () {
	renderAjaxCartItems();
}

function updateAjaxCartData() {
	let cartQty = document.querySelector('[data-qty]');
	let cartTotal = document.querySelector('[data-subtotal]');
	let cartData = this.getCartItemsAjax();
	let iconCounter = document.querySelector('.header__btn-cart__qty');

	cartData.done(function (cart) {
		let total = 0;

		cartQty.innerText = cart.item_count;
		iconCounter.textContent = cart.item_count;

		$('.item-price').each(function () {
			total += $(this).data('price');
		});

		cartTotal.innerText = Shopify.formatMoney(total);
	});
}

function checkIfCartEmpty() {
	let cartItemsWrapper = document.querySelector('#ajax-cart-drawer .drawer-content');

	let cartData = this.getCartItemsAjax();

	cartData.done(function (cart) {
		if (cart.item_count > 0) {
			if (cartItemsWrapper.classList.contains('empty')) {
				cartItemsWrapper.classList.remove('empty');
			}
		} else {
			cartItemsWrapper.classList.add('empty');
		}
	});
}

// RENDERS ---------------------
function renderAjaxCartItems(flag = true) {
	let cartData = getCartItemsAjax();

	cartData.done(function (cart) {
		let itemsHtml = '';
		let itemsWrapperHtml = document.querySelector('#ajax-cart-drawer .drawer-content');
		let cartOpener = document.querySelector('.header__btn-cart');

		cart.items.forEach((el, index) => {
			itemsHtml += renderCart(el, index);
		});

		itemsWrapperHtml.innerHTML = '';
		// $this.checkIfCartEmpty();
		if (flag) {
			cartOpener.click();
		}

		setTimeout(() => {
			itemsWrapperHtml.innerHTML = itemsHtml;
			jcf.replace($('.item-qty'));
			addRemoveListeners();
			addChangeProductsQtyListeners();
			updateAjaxCartData();
			checkIfCartEmpty();

			if (sessionStorage.getItem('dicount') != null) {
				$('#quantityDiscountDrawer').val(sessionStorage.getItem('dicount'));
			}
		}, 600);
	});
}

function renderCart(cartObject, index) {
	let comparePrice = '';
	let price = '';

	if (cartObject.properties && cartObject.properties.bundle == 'true') {
		price = Shopify.formatMoney((cartObject.price * cartObject.quantity) * 0.9);
	} else {
		price = Shopify.formatMoney(cartObject.price * cartObject.quantity);
	}

	$.ajax({
		type: "GET",
		url: `/products/${cartObject.handle}?view=ajax`,
		async: false,
		dataType: 'json',
		success: function (response) {
			window.currentJsonProduct = response.product.variants.filter(item => item.id == cartObject.id)
		}
	});

	if (window.currentJsonProduct.compare_at_price != 0) {
		comparePrice = Shopify.formatMoney(window.currentJsonProduct[0].compare_at_price.replace('.', '') * cartObject.quantity);
	}

	return `
			<div class="drawer__item animate__animated" data-id="${cartObject.id}" data-price="${cartObject.price}" data-compare="${window.currentJsonProduct[0].compare_at_price.replaceAll('.', '')}">
			 <div class="drawer__item-image">
			  <img src="${cartObject.image}" alt="product item">
			 </div>
		
			 <div class="drawer__item-content">
			  <h3 class="content-title">
			   ${cartObject.title.split(' - ')[0]}
			   
			   <a class="drawer-remove__item" data-id="${cartObject.id }">
				   <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.52424 5.5L10.173 10M0.875488 10L5.52424 5.5L0.875488 10ZM10.173 1L5.52335 5.5L10.173 1ZM5.52335 5.5L0.875488 1L5.52335 5.5Z" stroke="#1C1C25" stroke-linecap="round" stroke-linejoin="round"/>
				   </svg>
			   </a>
			  </h3>
		
			  <p class="content-variant">
			    ${cartObject.options_with_values[0].name}: ${cartObject.options_with_values[0].value}
			  </p>
		
			  <div class="content-qty-price">
			   <div class="content-qty-wrapper">
				<input type="number" value="${cartObject.quantity}" min="1" class="item-qty">
			   </div>
		
			   <div class="content-price-wrapper">
				<h5 class="item-price" data-price="${price.replaceAll('$', '').replaceAll('.', '')}">
				 ${price}
				</h5>
		
				<span class="item-compared-price">
				 ${comparePrice}
				</span>
			   </div>
			  </div>
			 </div>
			</div>
		`;
}

// AJAX REQUESTS ---------------
function getCartItemsAjax() {
	return $.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		async: false
	});
}

function clearCartItemsAjax() {
	$.ajax({
		type: "POST",
		url: '/cart/clear.js',
		data: '',
		dataType: 'json',
		success: function () {
		}
	});
}

function removeCartItemAjax(id, el) {
	$.ajax({
		type: "POST",
		url: '/cart/update.js',
		data: {
			updates: {
				[`${id}`]: 0
			}
		},
		dataType: 'json',
		success: function () {
			el.classList.add('animate__fadeOutRight');
			el.addEventListener('animationend', () => {
				el.remove();
			});

			checkIfCartEmpty();
		}
	});
}

function addCartItemAjax(id, qty) {
	$.ajax({
		type: "POST",
		url: '/cart/add.js',
		async: false,
		data: {
			items: [
				{
					id: id,
					quantity: qty
				}
			]
		},
		dataType: 'json',
		success: function (response) {
			console.log(response);
			checkIfCartEmpty();
		},
		error: function (request, status, error) {
			let responseJSON = JSON.parse(request.responseText);

			console.log(responseJSON.message);
		}
	});
}

// LISTENERS
function addRemoveListeners() {
	let allItemsInCart = document.querySelectorAll('.drawer__item');

	allItemsInCart.forEach((el) => {
		el.querySelector('.drawer-remove__item').addEventListener('click', (e) => {
			e.preventDefault();

			let id = e.target.dataset.id;
			removeCartItemAjax(id, el);

			setTimeout(() => {
				// $this.checkIfCartEmpty();
				updateAjaxCartData();
			}, 2000)
		});
	});
}

function addChangeProductsQtyListeners() {
	let items = document.querySelectorAll('.drawer-content .drawer__item');

	items.forEach((el) => {
		let id = el.dataset.id;
		let elPrice = el.dataset.price;
		let elComparePrice = el.dataset.compare;
		let priceWrapper = el.querySelector('.item-price');
		let priceCompareWrapper = el.querySelector('.item-compared-price');

		$(el).find('input.item-qty').on('change', function () {
			updateCartItemAjax(id, $(this).val());

			priceWrapper.textContent = Shopify.formatMoney(elPrice * $(this).val());
			priceCompareWrapper.textContent = Shopify.formatMoney(elComparePrice * $(this).val());
		});
	});
}

function updateCartItemAjax(id, qty) {
	$.ajax({
		type: "POST",
		url: '/cart/update.js',
		async: false,
		data: {
			updates: {
				[`${id}`]: qty
			}
		},
		dataType: 'json',
		success: function (cart) {
			updateAjaxCartData();
		},
		error: function (jqXhr, textStatus, errorMessage) {
			console.log('Error: ' + errorMessage);
		}
	});
}
// END AJAX


// document.addEventListener("DOMContentLoaded", function () {
//     window.productGallery.on('slideChange', function () {
//         console.log('change');

//         if ($('.swiper-slide.swiper-slide-visible video').length > 0) {
//             $('.swiper-slide.swiper-slide-visible video')[0].play();
//         } else {
//             $('.swiper-slide video')[0].load()
//         }
//     });
// });
